export default "__VITE_ASSET__DKq0UnFy__"